module.exports = __webpack_public_path__ + "components/flag/static/square/ag-8ed8bba5ede230ee63212aa0a9616a42.svg";